import set from 'lodash/set'
import get from 'lodash/get'

class Analytics {
  constructor(type, dataObj, title, propagationHandler, api) {
    this.type = type
    this.title = title
    this.dataObj = dataObj
    this.propagationHandler = this.parseHandler(propagationHandler)
    this.api = api
  }

  parseHandler(handler) {
    // if the hander is a direct function reference, just return it
    if(typeof handler === 'function') {
      return handler
    }
    
    return get(window, handler.callback.replace(new RegExp(/^window./), ''))
  }

  linkClick(link) {
    set(this.dataObj, 'page.linkDetails', {
      linkText: link.text,
      linkType: link.type
    })

    this.submitData('analytics.linkClick')
  }

  downloadClick(link) {
    set(this.dataObj, 'page.linkDetails', {
      linkText: link.text,
      linkType: link.type,
      fileName: link.filename,
      fileType: link.filetype
    })

    this.submitData('analytics.linkClick')
  }

  saveFilter(state) {
    set(this.dataObj, 'page.linkDetails', {
      linkText: state ? state.text : '',
      linkType: state ? state.type : ''
    })
  }

  setPagination(page) {
    set(this.dataObj, 'page.pageInfo.tabPageNumber', page._page)
  }

  defaultFilterContent(filterArr) {
    if(!filterArr || filterArr.length < 1) {
      return false
    }

    let filterOutput = []

    filterOutput = filterArr.map((filterItem) => {
      return {
        filterType: 'default filter',
        filterName: filterItem.title,
        filterValue: (() => {
          if (filterItem.type === 'search' || filterItem.type === 'dateSingle' || filterItem.type === 'dateRange') {
            return 'user defined'
          }

          if (Array.isArray(filterItem.values)) {
            return filterItem.values.join(',')
          }

          return filterItem.values
        })()
      }
    })

    set(this.dataObj, 'page.filters', filterOutput)

    this.submitData('analytics.filterContent')
  }

  filterContent(filterArr, sort, page, customFilter, search) {
    let filterOutput = []

    set(this.dataObj, 'page.linkDetails', {
      linkText: '',
      linkType: ''
    })

    if (page) {
      this.setPagination(page)
    }

    filterOutput = filterArr.map((filterItem) => {
      return {
        filterType: 'column filter',
        filterName: filterItem.title,
        filterValue: (() => {
          if (filterItem.type === 'search' || filterItem.type === 'dateSingle' || filterItem.type === 'dateRange') {
            return 'user defined'
          }

          if (Array.isArray(filterItem.values)) {
            return filterItem.values.join(',')
          }

          return filterItem.values
        })()
      }
    })

    if (sort) {
      filterOutput.push({
        filterType: 'table filter',
        filterName: sort._sort,
        filterValue: sort._order
      })
    }

    if (search && search !== '') {
      filterOutput.push({
        filterType: 'table filter',
        filterName: 'search',
        filterValue: 'user defined'
      })
    }

    if (filterOutput.length < 1) {
      filterOutput.push({
        filterType: '',
        filterName: '',
        filterValue: ''
      })
    } else if (customFilter) {
        filterOutput.push({
          filterType: 'table filter',
          filterName: customFilter.type,
          filterValue: (customFilter.type === 'quick') ? customFilter.name : 'user defined' // undefined on server...
        })
      }

    set(this.dataObj, 'page.filters', filterOutput)

    this.submitData('analytics.filterContent')
  }

  submitData(type) {
    // decorate all requests with static table name
    set(this.dataObj, 'page.pageInfo.tableName', this.title)

    if (window && window.PubSub && window.PubSub.publish) {
      window.PubSub.publish(type, this.dataObj)
    }
  }

  generateEventFilters() {
    const output = {
      pagination: this.api.getPagination().offset,
      filters: this.api.getFiltersAsList(),
      sort: this.api.getSort()
    }

    if(this.api.getCustomFilter()) {
      output.customFilterType = this.api.getCustomFilterType()
    }
    
    return output
  }

  propagateEvent(data) {
    if(!this.propagationHandler) {
      return false
    }

    const output = Object.assign({}, data);

    output.title = this.title;
    output.filters = this.generateEventFilters()

    this.propagationHandler(output);
  }
}

export default Analytics
